import axios from 'axios'

import auth from '../auth/service'

export let BASE_URL = '' // sembra che si possa fare, anche se brutto
if (process.env.REACT_APP_ENV === 'production') {
  BASE_URL = 'https://ranking.webranking.tools'
} else if (process.env.REACT_APP_ENV === 'staging') {
  BASE_URL = 'https://staging.ranking.webranking.tools'
} else {
  BASE_URL = 'http://localhost:9998'
}

const baseApiAddress = `${BASE_URL}/api/1/`

let _api = axios.create({
  baseURL: baseApiAddress,
})

_api.interceptors.request.use(
  (config) => {
    //if (process.env.NODE_ENV === 'production') {
    if (config.baseURL === baseApiAddress && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${auth.getAccessToken()}`
    }
    //}

    return config
  },
  (error) => Promise.reject(error)
)

export const api = _api

export const GTM_ID = process.env.REACT_APP_GTM_ID

export const capitalize = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const dateMonthYearFromString = (s) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  const splitted = s.split('-')
  return `${monthNames[Number(splitted[1]) - 1]} ${Number(splitted[0])}`
}

export const formatDateTime = data => {
  const d = new Date(data)
  const hours = d.getHours();
  let minutes = d.getMinutes();
  minutes = minutes < 10 ? '0'+minutes : minutes;
  const strTime = hours + ':' + minutes;
  return d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + "  " + strTime;
}

export const defaultFilters = [
  {
    "groupType": "and",
    "filters": [
      {
        "dimension": "page",
        "operator": "notContains",
        "expression": ".pdf"
      },
      {
        "dimension": "page",
        "operator": "notContains",
        "expression": ".doc"
      }
    ]
  }
]